// @ts-nocheck
import styles from './Body.module.scss';
import classNames from 'classnames';
import { ReactComponent as EmptyDataIcon } from '../../../../assets/images/empty-data.svg';
import { Fragment } from 'react';
import TableCheckbox from '../TableCheckbox/TableCheckbox';

const Body = props => {
    const {
        data,
        expandable,
        rowSelection,
        onSelect,
        getRowClassName,
        getRowKey,
        isExpandable,
        onRowExpand,
        tableColumns,
        checkedRows,
    } = props;
    const { expandIcon, expandRowByClick, expandedRowKeys, expandedRowRender } = expandable;

    return (
        <tbody>
            {data.map(rowData => {
                const rowKey = getRowKey(rowData);
                const isExpanded = expandedRowKeys && expandedRowKeys.includes(rowKey);
                const isChecked = checkedRows.find(row => getRowKey(row) === rowKey);
                const rowClassName = getRowClassName?.(rowData) || '';

                return (
                    <Fragment key={rowKey}>
                        <tr
                            className={classNames(styles.row, rowClassName, {
                                expandable: expandable.expandRowByClick,
                            })}
                            onClick={e => onRowExpand(e, isExpanded, rowData)}
                        >
                            {rowSelection ? (
                                <td className={'checkbox'}>
                                    <TableCheckbox checked={isChecked} onSelect={onSelect} rowData={rowData} />
                                </td>
                            ) : null}
                            {expandRowByClick ? (
                                <td className={'expandIcon'}>
                                    {expandIcon &&
                                        expandIcon({
                                            expanded: isExpanded,
                                            onExpand: onRowExpand,
                                            record: rowData,
                                        })}
                                </td>
                            ) : null}
                            {tableColumns.map(column => {
                                return (
                                    column && (
                                        <td
                                            key={column.key}
                                            className={classNames(styles.column, column.className)}
                                            style={{ width: column.width, minWidth: column.width }}
                                        >
                                            {column.render
                                                ? column.render(
                                                      column.dataIndex ? rowData[column.dataIndex] : rowData,
                                                      rowData
                                                  )
                                                : rowData[column.dataIndex]}
                                        </td>
                                    )
                                );
                            })}
                        </tr>
                        {isExpandable && isExpanded ? (
                            <tr className={styles.expandedRow}>
                                <td colSpan={tableColumns.length + 1}>{expandedRowRender(rowData)}</td>
                            </tr>
                        ) : null}
                    </Fragment>
                );
            })}
            {!data.length && (
                <tr>
                    <td colSpan={isExpandable ? tableColumns.length + 1 : tableColumns.length}>
                        <div className={styles.emptyData}>
                            <div className={styles.emptyImage}>
                                <EmptyDataIcon />
                            </div>
                            <div>No data</div>
                        </div>
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default Body;
